/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SetClearanceCaseManagerResult {
  Error = 0,
  Success = 1,
  InvalidCase = 2,
  InvalidUser = 3,
}
